import {FC, useCallback, useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { postNewSubscription } from '../../../../common/async/AsyncCalls';
import { addLocalStorageItem } from '../../../../common/helpers/LocalStorage';
import { IPaymentState } from '../../../../common/state/payments/payment';
import { IUserState } from '../../../../common/state/profile/user';
import { IGeneralInfoState } from '../../../../common/state/subscriptions/general_info';
import { IPaymentInfo, IPaymentInfoState } from '../../../../common/state/subscriptions/payment_info';
import { IPersonalInfo, IPersonalInfoState } from '../../../../common/state/subscriptions/personal_info';
import { ISubscription } from '../../../../common/state/subscriptions/subscription';
import SimpleSpinner from '../../../../components/loaders/spinners/SimpleSpinner';
import StripeCheckoutContainer from '../../../../components/stripe/StripeCheckoutContainer';
// css
import './checkout.form.css';

const CheckoutForm: FC = () => {
    // states
    const [loading, toggleLoading] = useState(true);
    const [spinnerTitle, setSpinnerTitle] = useState<string>('Initializing Stripe form...');
    const token = useSelector(({user} : {
        user: IUserState
    }) => user.token);
    const signature = useSelector(({payment} : {
        payment: IPaymentState
    }) => payment.signature);
    const general_info = useSelector(({general_info} : {
        general_info: IGeneralInfoState
    }) => general_info.selected);
    const personal_info: IPersonalInfo | undefined = useSelector(({personal_info}: {personal_info: IPersonalInfoState}) => personal_info.selected);    
    const payment_info: IPaymentInfo | undefined = useSelector(({payment_info}: {payment_info: IPaymentInfoState}) => payment_info.selected);    
    const amount = general_info?.final_price?? 0;
    const name: string = personal_info?.first_name?? 'Test' + personal_info?.last_name?? 'User';


    // lifecycle
    const createNewSubscriptionRecord = useCallback(async()=>{
        setSpinnerTitle('Initializing subscription');
        console.log('Details: ', token, general_info, personal_info, payment_info);
        if (token && general_info && personal_info && payment_info) {
            try {
                toggleLoading(true);
                const payload: ISubscription = {
                    general_info,
                    personal_info,
                    payment_info
                };
                const response = await postNewSubscription(token, payload);
                toast(`Subscription record created!`);
                const {id} = response.data;
                if (id) addLocalStorageItem('subscription', id);
            } catch (err) {
                console.log('Error creating subscription record: ', err);
                toast(`Error creating subscription record!`);
            } finally {
                toggleLoading(false);
            }                        
        }
    },[token, general_info, personal_info, payment_info]);
    useEffect(()=> {
        if (signature !== '') toggleLoading(false);
        createNewSubscriptionRecord();
    },[signature, general_info, amount, name]);
        
    return <section
        className="flex flex-col items-center w-full p-4 my-3 mr-3 bg-white shadow-lg stripe-buttons stripe-button lg:w-1/2 rounded-xl dark:bg-gray-900">
            <SimpleSpinner loading={loading} title={spinnerTitle}/>
            {Boolean(signature !== '') && <StripeCheckoutContainer 
                stripe_signature={signature}
                amount={amount}
                description={`${name} wants to register for the conference - ${general_info?.event_title ?? 'Leadership Seminar'}`}/>}
    </section>;
};

export default CheckoutForm;